<template>
  <section class="evaluation">
    <div class="evaluation__suggested">
      <div class="form-group row ">
        <div class="col-sm-4">
          Sugerowany wynik oceny:
        </div>
        <div class="col-sm-8 evaluation__suggested-result">
          {{ suggestedCertificationStatusLabel() }}
        </div>
      </div>
    </div>

    <RadioControl
      id="evaluation-new-status"
      v-model="newStatus"
      :options="evaluationStatusFiltered"
      :get-object="false"
      label="Po zapisaniu ustaw status na:"
      label-class="col-sm-4"
      control-class="col-sm-8"
    />
  </section>
</template>

<script>
import RadioControl from "@/components/Controls/RadioControl";

import { suggestedCertificationStatus } from "@/helpers/Certification";
import { mapState } from "vuex";

import { i18n } from "@/i18n/";

const evaluationStatus = [
  { id: "moderation", name: i18n.t("status_evaluation_moderation") },
  { id: "corrective", name: i18n.t("status_evaluation_corrective") },
  { id: "compliant", name: i18n.t("status_evaluation_compliant") },
  {
    id: "compliant_location",
    name: i18n.t("status_evaluation_compliant_location")
  },
  { id: "conditional", name: i18n.t("status_evaluation_conditional") },
  { id: "not_compliant", name: i18n.t("status_evaluation_not_compliant") },
  { id: "insufficent", name: i18n.t("status_evaluation_insufficent") },
  { id: "rejected", name: i18n.t("status_evaluation_rejected") },
  { id: "none", name: i18n.t("status_evaluation_none") }
];

export default {
  name: "BaseAdminCertificationEvaluation",
  components: {
    RadioControl
  },
  data() {
    return {
      newStatus: "moderation"
    };
  },
  computed: {
    ...mapState("Event", ["event", "comments"]),
    evaluationStatusFiltered() {
      let status = evaluationStatus;
      let event = this.$store.getters["Event/getEvent"];
      let comments = this.$store.getters["Event/getComments"];
      let suggested = this.suggestedCertificationStatus(event, comments);
      let alwaysVisible = ["moderation", "rejected", "insufficent", "none"];

      status = status.filter(item => {
        return alwaysVisible.includes(item.id) || suggested.includes(item.id);
      });

      return status;
    }
  },
  watch: {
    evaluationStatusFiltered(newValue, oldValue) {
      let a = newValue
        .map(item => item.id)
        .sort()
        .join();
      let b = oldValue
        .map(item => item.id)
        .sort()
        .join();
      if (a !== b) {
        this.newStatus = "moderation";
      }
    },
    newStatus() {
      this.$emit("input", this.newStatus);
    }
  },
  methods: {
    suggestedCertificationStatus,
    suggestedCertificationStatusLabel() {
      let suggested = this.suggestedCertificationStatus(
        this.event,
        this.comments
      );

      suggested = suggested
        .map(item =>
          item !== "unknown"
            ? '"' + i18n.t(`status_${item}`) + '"'
            : i18n.t(`status_unknown`)
        )
        .join(" lub ");

      return suggested;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";
</style>
